
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signin/[[...lang]]",
      function () {
        return require("private-next-pages/signin/[[...lang]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signin/[[...lang]]"])
      });
    }
  